<app-menu>
    <mat-card>
        <mat-card-header>
            <mat-card-title>Spot Quote</mat-card-title>
        </mat-card-header>
        <br>
        <mat-card-content>
            <mat-button-toggle-group name="quote_type" #quoteGroup="matButtonToggleGroup">
                <mat-button-toggle value="details" checked><mat-icon style="color: lightblue;">list</mat-icon><span
                        style="padding: 10px 5px; font-weight: bold; font-size: 15px;">Details</span></mat-button-toggle>
                <mat-button-toggle value="rates"><mat-icon style="color: lightblue;">account_balance</mat-icon><span
                        style="padding: 10px 5px; font-weight: bold; font-size: 15px;">Rates</span></mat-button-toggle>
                <mat-button-toggle value="financials"><mat-icon style="color: lightblue;">local_offer</mat-icon><span
                        style="padding: 10px 5px; font-weight: bold; font-size: 15px;">Financials</span></mat-button-toggle>
            </mat-button-toggle-group>
            <br><br>
            <div *ngIf="quoteGroup.value == 'details'" [formGroup]="quote_details_form">
                <div style="display: flex ; flex: 1;justify-content: space-between; flex-wrap: wrap;">
                    <!-- <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Customer</mat-label>
                            <input matInput placeholder="Start Typing Customer Name...">
                        </mat-form-field>
                    </span> -->
                    <app-contact-autocomplete 
                        placeholder="Start typing customer name..." 
                        [type]="'customer_contact_list'" 
                        [formControl]="customerNameControl" 
                        (selected)="onCustomerSelected($event)" 
                        style="flex-basis: 22%;"
                    >
                    </app-contact-autocomplete>
                    <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Rate Method</mat-label>
                            <mat-select formControlName="rate_method">
                                <mat-option value='1'>Cubic Feet</mat-option>
                                <mat-option value='2'>Weight</mat-option>
                                <mat-option value='3'>Linear Feet</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </span>
                    <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Partial or Full</mat-label>
                            <mat-select formControlName="partial_or_full">
                                <mat-option value='Partial'>Partial</mat-option>
                                <mat-option value='Full'>Full</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </span>
                    <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Shipment Type</mat-label>
                            <mat-select formControlName="shipment_type">
                                <mat-option value='FEET'>Feet</mat-option>
                                <mat-option value='CRATE'>Crate</mat-option>
                                <mat-option value='PALLET'>Pallet</mat-option>
                                <mat-option value='PIECE'>Piece</mat-option>
                                <mat-option value='SKID'>Skid</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </span>
                    <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Equipment Type</mat-label>
                            <mat-select formControlName="equipment_type">
                                <mat-option value='V'>Van</mat-option>
                                <mat-option value='R'>Refrigerated Carrier (Reefer)</mat-option>
                                <mat-option value='F'>Flatbed</mat-option>
                                <mat-option value='B_TR'>B-Train/Supertrain</mat-option>
                                <mat-option value='CONG'>Conestoga</mat-option>
                                <mat-option value='CONT'>Container Trailer</mat-option>
                                <mat-option value='DD'>Double Drop</mat-option>
                                <mat-option value='DDE'>Double Drop Extendable</mat-option>
                                <mat-option value='LB'>Lowboy</mat-option>
                                <mat-option value='SD'>Step Deck</mat-option>
                                <mat-option value='SDE'>Step Deck Extendable</mat-option>
                                <mat-option value='SDL'>Step Deck w/Loading Ramps</mat-option>
                                <mat-option value='SV'>Straight Van</mat-option>
                                <mat-option value='VM'>Moving Van</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </span>
                    <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Equipment Option</mat-label>
                            <mat-select formControlName="equipment_option">
                                <mat-option value='Tarps'>Tarps</mat-option>
                                <mat-option value='Hazardous'>Hazardous</mat-option>
                                <mat-option value='PalletExchange'>PalletExchange</mat-option>
                                <mat-option value='Team'>Team</mat-option>
                                <mat-option value='Expedited'>Expedited</mat-option>
                                <mat-option value='Bonded'>Bonded</mat-option>
                                <mat-option value='Power Tailgate'>Power Tailgate</mat-option>
                                <mat-option value='Spot/Drop Trailer'>Spot/Drop Trailer</mat-option>
                                <mat-option value='Mult-Stop'>Mult-Stop</mat-option>
                                <mat-option value='Blanket Wrap'>Blanket Wrap</mat-option>
                                <mat-option value='Temperature Control'>Temperature Control</mat-option>
                                <mat-option value='Air Ride'>Air Ride</mat-option>
                                <mat-option value='Satellite Tracking'>Satellite Tracking</mat-option>
                                <mat-option value='Heated'>Heated</mat-option>
                                <mat-option value='Lumper/Swamper'>Lumper/Swamper</mat-option>
                                <mat-option value='Tradeshow'>Tradeshow</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </span>
                    <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Load Length</mat-label>
                            <input matInput placeholder="Load Length" formControlName="load_length" type="number">
                        </mat-form-field>
                    </span>
                    <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Load Start</mat-label>
                            <input matInput [matDatepicker]="picker1" formControlName="load_start">
                            <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                    </span>
                    <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Load End</mat-label>
                            <input matInput [matDatepicker]="picker2" formControlName="load_end">
                            <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                    </span>
                    <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Quote Start</mat-label>
                            <input matInput [matDatepicker]="picker3" formControlName="quote_start">
                            <mat-datepicker-toggle matIconSuffix [for]="picker3"></mat-datepicker-toggle>
                            <mat-datepicker #picker3></mat-datepicker>
                        </mat-form-field>
                    </span>
                    <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Quote Expiry</mat-label>
                            <input matInput [matDatepicker]="picker4" formControlName="quote_expiry">
                            <mat-datepicker-toggle matIconSuffix [for]="picker4"></mat-datepicker-toggle>
                            <mat-datepicker #picker4></mat-datepicker>
                        </mat-form-field>
                    </span>
                    <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Contact Person</mat-label>
                            <input matInput placeholder="Contact Person" formControlName="contact_person">
                        </mat-form-field>
                    </span>
                    <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Sales Person</mat-label>
                            <mat-select formControlName="sales_person">
                                <mat-option *ngFor="let item of salesPersonList" [value]="item">
                                    {{item}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </span>
                    <span style="flex-basis: 22%;">
                        <mat-form-field style="width: 100%;">
                            <mat-label>Note</mat-label>
                            <input matInput placeholder="Note" formControlName="note">
                        </mat-form-field>
                    </span>
                    <span style="flex-basis: 22%;"></span>
                    <span style="flex-basis: 22%;"></span>
                </div>
                <hr><br>
                <div>
                    <mat-button-toggle-group name="sourceSearchType" #originGroup="matButtonToggleGroup">
                        <mat-button-toggle value="origincity" checked>Search by City</mat-button-toggle>
                        <mat-button-toggle value="originpostalcode">Search by Postal/ZIP Code</mat-button-toggle>
                    </mat-button-toggle-group>
                    <br><br>
                    <div class="error" *ngIf="(submittedQuoteDetailsForm || quote_details_form.get('origin')?.get('postal_code')?.touched) && quote_details_form.get('origin')?.get('postal_code')?.errors?.['postalCodeInvalid']">
                        Enter a valid Canadian postal code or US zip code.    
                    </div>
                    <div class="error" *ngIf="(submittedQuoteDetailsForm || quote_details_form.get('origin')?.touched) && quote_details_form.get('origin')?.errors?.['cityRegionRequired']">
                        If postal code is empty, city and province/state are required.
                    </div>
                    <div style="display: flex; justify-content: flex-start; gap: 20px;" formGroupName="origin">
                        <span style="flex-basis: 30%;" *ngIf="originGroup.value == 'origincity'">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Origin City:</mat-label>
                                <input matInput formControlName="city">
                            </mat-form-field>
                        </span>
                        <span style="flex-basis:30%" *ngIf="originGroup.value=='originpostalcode'">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Origin Postal Code:</mat-label>
                                <input matInput formControlName="postal_code">
                            </mat-form-field>
                        </span>
                        <span style="flex-basis: 30%;" *ngIf="originGroup.value == 'origincity'">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Origin Province/State:</mat-label>
                                <input matInput placeholder="Source Province/State" formControlName="region">
                            </mat-form-field>
                        </span>
                    </div>
                    <mat-button-toggle-group name="destinationSearchType" #destinationGroup="matButtonToggleGroup">
                        <mat-button-toggle value="city" checked>Search by City</mat-button-toggle>
                        <mat-button-toggle value="postalcode">Search by Postal/ZIP Code</mat-button-toggle>
                    </mat-button-toggle-group>
                    <br><br>
                    <div class="error" *ngIf="(submittedQuoteDetailsForm || quote_details_form.get('destination')?.get('postal_code')?.touched) && quote_details_form.get('destination')?.get('postal_code')?.errors?.['postalCodeInvalid']">
                        Enter a valid Canadian postal code or US zip code.    
                    </div>
                    <div class="error" *ngIf="(submittedQuoteDetailsForm || quote_details_form.get('destination')?.touched) && quote_details_form.get('destination')?.errors?.['cityRegionRequired']">
                        If postal code is empty, city and province/state are required.
                    </div>
                    <div style="display: flex; justify-content: flex-start; gap: 20px;" formGroupName="destination">
                        <span style="flex-basis: 30%;" *ngIf="destinationGroup.value == 'city'">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Destination City:</mat-label>
                                <input matInput formControlName="city">
                            </mat-form-field>
                        </span>
                        <span style="flex-basis: 30%;" *ngIf="destinationGroup.value == 'postalcode'">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Destination Postal Code:</mat-label>
                                <input matInput formControlName="postal_code">
                            </mat-form-field>
                        </span>
                        <span style="flex-basis: 30%;" *ngIf="destinationGroup.value == 'city'">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Destination Province/State:</mat-label>
                                <input matInput formControlName="region">
                            </mat-form-field>
                        </span>
                    </div>
                    <mat-form-field style="width: 30%;">
                        <mat-label>Order Scope</mat-label>
                        <mat-select formControlName="order_scope">
                            <mat-option *ngFor="let item of getOrderScope()" [value]="item">
                                {{item}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div>
                        <mat-card-subtitle>Service Charge</mat-card-subtitle>
                        <form [formGroup]="service_charge_info">
                            <div formArrayName="service_list">
                                <div *ngFor="let sub_servicee_form of service_list.controls; let i = index;">
                                    <mat-card-subtitle>Added Service Charge {{i + 1}}</mat-card-subtitle>
                                    <div [formGroupName]="i"
                                        style="display: flex; justify-content: flex-start; gap: 20px;">
                                        <mat-form-field style="flex-basis: 30%;">
                                            <mat-select formControlName="services">
                                                <mat-option *ngFor="let service of getServices()" [value]="service">
                                                    {{service}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field style="flex-basis: 30%;"
                                            *ngIf="service_charge_info.get('service_list.'+i+'.services')?.value.length > 0">
                                            <mat-select formControlName="service_types">
                                                <mat-option
                                                    *ngFor="let service_type of getServiceType(service_charge_info.get('service_list.'+i+'.services')?.value)"
                                                    [value]="service_type">
                                                    {{service_type}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <button (click)="deleteService(i)" mat-raised-button
                                            color="warn">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <button (click)="addService()" mat-raised-button color="primary">Add</button>
                    </div>
                    <br>
                    <div [formGroup]="palletForm">
                        <mat-card-title>Pallets</mat-card-title>
                        <mat-button-toggle-group name="palletUnit" #palletGroup="matButtonToggleGroup">
                            <mat-button-toggle value="pallets" checked>By Pallet
                                Dimensions</mat-button-toggle>
                            <mat-button-toggle value="linearFeet">By Linear Feet</mat-button-toggle>
                        </mat-button-toggle-group>
                        <br><br>
                        <mat-card style="padding-left: 10px;" formArrayName="palletList">
                            <div *ngFor="let item of palletListArray().controls; let i = index;">
                                <mat-card-subtitle>Pallet Set {{i + 1}}</mat-card-subtitle>
                                <div [formGroupName]="i" style="display: flex; justify-content: flex-start; gap: 10px;">
                                    <mat-form-field [ngStyle]="{'width.%': palletGroup.value == 'pallets' ? 100 : 30}">
                                        <mat-label>{{palletGroup.value == 'pallets' ? 'Number of Pallets:' : 'Number of
                                            Linear Feet:'}}</mat-label>
                                        <input matInput
                                            placeholder="{{palletGroup.value == 'pallets' ? 'Number of Pallets:' : 'Number of Linear Feet'}}"
                                            formControlName="numberOfPallets"    
                                        >
                                    </mat-form-field>
                                    <mat-form-field style="width: 100%;" *ngIf="palletGroup.value == 'pallets'">
                                        <mat-label>Pallet Length (inches):</mat-label>
                                        <input matInput placeholder="Pallet Length" formControlName="palletLength">
                                    </mat-form-field>
                                    <mat-form-field style="width: 100%;" *ngIf="palletGroup.value == 'pallets'">
                                        <mat-label>Pallet Width (inches):</mat-label>
                                        <input matInput placeholder="Pallet Width" formControlName="palletWidth">
                                    </mat-form-field>
                                    <mat-form-field style="width: 100%;" *ngIf="palletGroup.value == 'pallets'">
                                        <mat-label>Pallet Height (inches):</mat-label>
                                        <input matInput placeholder="Pallet Height" formControlName="palletHeight">
                                    </mat-form-field>
                                    <mat-form-field style="width: 100%;" *ngIf="palletGroup.value == 'pallets'">
                                        <mat-label>Pallet Weight (pounds):</mat-label>
                                        <input matInput placeholder="Pallet Weight" formCOntrolName="palletWeight">
                                    </mat-form-field>
                                </div>

                            </div>
                            <div style="display: flex; justify-content: flex-start; gap: 15px; margin-bottom: 10px;">
                                <button class="hover-effect-button" style="width: 15%;" (click)="addPallet()"
                                    mat-raised-button color="primary"><mat-icon>add</mat-icon>Add Pallet Set</button>
                                <button class="hover-effect-remove" style="width: 15%;" (click)="removePallet()"
                                    *ngIf="counter > 1" mat-raised-button color="warn"><mat-icon>remove</mat-icon>Remove
                                    Last Pallet Set</button>
                            </div>
                        </mat-card>
                    </div>
                    <div style="display: flex; margin-top: 10px;">
                        <button style="margin-left: auto; font-size: 15px;" mat-raised-button color="primary" (click)="searchDetailQuotes()"><i
                                class="fa-solid fa-magnifying-glass"></i><span
                                style="padding: 10px 5px;"></span>Search</button>
                    </div>
                </div>
            </div>

            <div *ngIf="quoteGroup.value == 'rates'">
                <p>rates</p>
            </div>

            <div *ngIf="quoteGroup.value == 'financials'">
                <div>
                    <h2>Financial</h2>
                    <mat-form-field style="width: 30%;">
                        <mat-label>Carrier Name:</mat-label>
                        <input matInput placeholder="Start typing carrier name...">
                    </mat-form-field>
                </div>
                <div>
                    <form
                        style="display:flex;border:1px solid grey;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Currency Types</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost</mat-label>
                                <mat-select>
                                    <mat-option value='CAD'>CAD</mat-option>
                                    <mat-option value='USD'>USD</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable</mat-label>
                                <mat-select>
                                    <mat-option value='CAD'>CAD</mat-option>
                                    <mat-option value='USD'>USD</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </form>
                    <form
                        style="display:flex;border:1px solid grey;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Freight</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost:</mat-label>
                                <input type="number" matInput placeholder="Click on a Current Rate" value="">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable:</mat-label>
                                <input type="number" matInput placeholder="" value="">
                            </mat-form-field>
                        </div>
                    </form>
                    <form
                        style="display:flex;border:1px solid grey;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Rate Per Mile</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost:</mat-label>
                                <input matInput placeholder="Click on a Current Rate" value="">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable:</mat-label>
                                <input matInput placeholder="" value="">
                            </mat-form-field>
                        </div>
                    </form>
                    <form
                        style="display:flex;border:1px solid grey;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Carbon Tax Rate</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost:</mat-label>
                                <input type="number" matInput placeholder="Click on a Current Rate" value="">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable:</mat-label>
                                <input type="number" matInput placeholder="" value="">
                            </mat-form-field>
                        </div>
                    </form>
                    <form
                        style="display:flex;border:1px solid grey;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Carbon Tax</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost:</mat-label>
                                <input matInput placeholder="Click on a Current Rate" value="">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable:</mat-label>
                                <input matInput placeholder="" value="">
                            </mat-form-field>
                        </div>
                    </form>
                    <form
                        style="display:flex;border:1px solid grey;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Fuel Surcharge Rate</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost:</mat-label>
                                <input type="number" matInput placeholder="Click on a Current Rate" value="">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable:</mat-label>
                                <input type="number" matInput placeholder="" value="">
                            </mat-form-field>
                        </div>
                    </form>
                    <form
                        style="display:flex;border:1px solid grey;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Fuel Surcharge Plus Rate</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost:</mat-label>
                                <input type="number" matInput placeholder="Click on a Current Rate" value="">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable:</mat-label>
                                <input type="number" matInput placeholder="" value="">
                            </mat-form-field>
                        </div>
                    </form>
                    <form
                        style="display:flex;border:1px solid grey;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Fuel Surcharge</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost:</mat-label>
                                <input matInput placeholder="Click on a Current Rate" value="">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable:</mat-label>
                                <input matInput placeholder="" value="">
                            </mat-form-field>
                        </div>
                    </form>
                    <form
                        style="display:flex;border:1px solid grey;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Beyond</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost:</mat-label>
                                <input type="number" matInput placeholder="Click on a Current Rate" value="">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable:</mat-label>
                                <input type="number" matInput placeholder="" value="">
                            </mat-form-field>
                        </div>
                    </form>
                    <form
                        style="display:flex;border:1px solid grey;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Discount</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost:</mat-label>
                                <input type="number" matInput placeholder="Click on a Current Rate" value="">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable:</mat-label>
                                <input type="number" matInput placeholder="" value="">
                            </mat-form-field>
                        </div>
                    </form>
                    <form
                        style="display:flex;border:1px solid grey;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Tax Rate</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost:</mat-label>
                                <input type="number" matInput placeholder="Click on a Current Rate" value="">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable:</mat-label>
                                <input type="number" matInput placeholder="" value="">
                            </mat-form-field>
                        </div>
                    </form>
                    <form
                        style="display:flex;border:1px solid grey;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Tax</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost:</mat-label>
                                <input type="number" matInput placeholder="Click on a Current Rate" value="">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable:</mat-label>
                                <input type="number" matInput placeholder="" value="">
                            </mat-form-field>
                        </div>
                    </form>
                    <form
                        style="display:flex;border:1px solid grey;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Subtotal</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost:</mat-label>
                                <input type="number" matInput placeholder="Click on a Current Rate" value="">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable:</mat-label>
                                <input type="number" matInput placeholder="" value="">
                            </mat-form-field>
                        </div>
                    </form>
                    <form
                        style="display:flex;border:2px solid darkgreen;border-radius:7px;padding:10px;justify-content: space-between; padding-top: 18px;">
                        <mat-card-subtitle style="flex-basis: 50%; display: inline-block; height: auto;">
                            <span style="font-size: 18px;"><strong>Total</strong></span>
                        </mat-card-subtitle>
                        <div style="display: flex; justify-content: space-around; gap: 20px; flex-basis: 70%;">
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Cost:</mat-label>
                                <input type="number" matInput placeholder="Click on a Current Rate" value="">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 40%;">
                                <mat-label>Billable:</mat-label>
                                <input type="number" matInput placeholder="" value="">
                            </mat-form-field>
                        </div>
                    </form>
                </div>
                <div style="display: flex; justify-content: flex-end;">
                    <button style="padding: 20px; margin-top: 20px;" mat-raised-button color="primary">Submit Quote</button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</app-menu>